module.exports = "<p-selectButton [options]=\"items\" optionLabel=\"facilityName\" [(ngModel)]=\"item\" (onChange)=\"change()\"></p-selectButton>\n"